module.exports = __webpack_public_path__ + "img/zhuhai-2.f5270f51.jpg";